import React from "react";

import usePollenNavEffects from "./helper/usePollenNavEffects";
import PollenTopicsHeader from "../../components/Headers/pollen/PollenTopicsHeader";
import useIsStickyPollenNavStore from "../../sp-state/useIsStickyPollenNavStore";
import useShowPollenNavStore from "../../sp-state/useShowPollenNavStore";

import styles from "./DefaultPollenNavContainer.module.scss";
import PrimaryNavMenuWrapper from "@components/RedesignComponents/BuilderWrappers/PrimaryNavMenu/PrimaryNavMenu";

const DefaultPollenNavContainer: React.FC = props => {
  const { isSticky } = useIsStickyPollenNavStore(state => state);
  const { showPollenNav } = useShowPollenNavStore(state => state);

  usePollenNavEffects();

  const containerStyles = `${styles.defaultPollenNavContainer} ${
    isSticky && styles.isSticky
  } ${showPollenNav && styles.pollenNavIsExpanded}`;

  return (
    <div className={styles.defaultPollenNavContainerWrapper}>
      <PrimaryNavMenuWrapper noSticky hiddenMobile />
      <div className={containerStyles} data-testid="default-pollen-nav-c">
        <PrimaryNavMenuWrapper noSticky hiddenDesktop />
        <PollenTopicsHeader />
      </div>
    </div>
  );
};

export default DefaultPollenNavContainer;
